angular.module('moebiusProadapt').controller('ctrlParticipantSS',
    ['$rootScope', '$scope', '$http', 'moment', '$timeout', '$location', '$controller', 'mbsEtiService', 'mbsParticipantService', '$uibModal', 'growl',
        function ($rootScope, $scope, $http, moment, $timeout, $location, $controller, mbsEtiService, mbsParticipantService, $uibModal, growl) {

            $scope.initTreatmentsQvId = $scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__TRAITEMENT_RECUEIL_INITIAL').id;
            $scope.canFetchQuestions = false;
            $scope.questionsToAsk = [];
            $scope.initial_suggestions = null;
            $scope.merged_suggestions = null;
            $scope.panier = null;
            $scope.date_questions = null;
            $scope.date_suggestions = null;

            console.log('here', $scope.participant);
            $scope.currentSSQuestionKey = null;
            $scope.displayConfirm = false;
            $scope.initAtcListHasChanged = false;
            $scope.getQuestionList = function() {
                // detect change on traitements initiaux, if change, display confirm
                // if suggestions have already been validated, display confirm
                let confirmMessage = null;
                let confirmAnswer = false;
                // the first part below is triggered when validating traitements initiaux, (in mbs-participant-service)
                // if($scope.participant.participant_ss_etat.questions && $scope.initAtcListHasChanged){
                //     confirmMessage = "Les actions conseillées par l'algorithme \"Stopp/Start\" ont été impactées par un changement au niveau de la liste \"Traitements / Recueil initial\" qui impacte peut-être également la conciliation.\n" +
                //         "Souhaitez-vous recommencer de zéro toute la conciliation médicale ?";
                // }else
                if($scope.participant.participant_ss_etat && $scope.participant.participant_ss_etat.suggestions){
                    confirmMessage = "Des suggestions ont déjà été validées, elles seront vidées si vous relancez l'algorithme \"Stopp/Start\"\nVoulez-vous continuer ?";
                }
                if(confirmMessage){
                    confirmAnswer = confirm(confirmMessage);
                }
                //if confirm answer is no, propose to copy newly added init treatments to conciliation medicale
                // if($scope.initAtcListHasChanged && confirmMessage && !confirmAnswer){
                //     if(confirm("Vous avez choisi de ne pas relancer l'algorithme \"Stopp/Start\". Voulez vous recopier les traitements initiaux ajoutés dans la conciliation médicamenteuse ?")){
                //         let promise = $http.post('stopp-start/copy-to-conciliation/' + mbsEtiService.getCurrentEti().id + '/' + firstVisiteKey + '/' + $scope.participant.id, {atcList: $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]})
                //             .then(function(response){
                //                 console.log('getQuestionList', response);
                //                 $scope.questionsToAsk = response.data;
                //             });
                //         $rootScope.participantTracker.addPromise(promise);
                //     }
                // }
                // param is list of ATC from recueil initial
                if($scope.canFetchQuestions && ((confirmMessage && confirmAnswer) || confirmMessage==null)){
                    // if($scope.participant.participantTraitementsByQuestionVisiteId && $scope.participant.participantTraitementsByQuestionVisiteId.length){
                    console.log($scope.participant.participantTraitementsByQuestionVisiteId);
                    $scope.initAtcListHasChanged = false;
                    var firstVisiteKey = mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys[0];
                    // var promise = $http.post('etude-instance/save-participant-values/' + mbsEtiService.getCurrentEti().id + '/' + firstVisiteKey + '/' + 'new', participant)
                    let promise = $http.post('stopp-start/get-question-list/' + mbsEtiService.getCurrentEti().id + '/' + firstVisiteKey + '/' + $scope.participant.id, {atcList: $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]})
                        .then(function(response){
                            console.log('getQuestionList', response);
                            $scope.questionsToAsk = response.data.questions;
                            //update date
                            $scope.date_questions = $scope.formatDate(new Date(response.data.date_questions));
                            //empty suggestions
                            $scope.participant.participant_ss_etat.suggestions = $scope.suggestions = $scope.merged_suggestions = null;
                        });
                    $rootScope.participantTracker.addPromise(promise);
                }
                if(!$scope.canFetchQuestions){
                    // growl.error('Aucun traitement initial n\'a été saisi, veuillez saisir au moins un traitement avant de déclencher STOPP/START');
                }
            };

            // listening to event broadcasted to launch SS from participant service
            $scope.$on('eventLaunchSS', function(event, data) {
                $scope.getQuestionList();
            });

            $scope.validateFormSS = function(){
                // TODO to be changed with array of models when implemented
                let answers = _.map($scope.questionsToAsk,function(q){
                    return {key:q.key,value:q.value};
                });
                if(answers.length){
                    var firstVisiteKey = mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys[0];

                    let promise = $http.post('stopp-start/get-suggestions/' + mbsEtiService.getCurrentEti().id + '/' + firstVisiteKey + '/' + $scope.participant.id, {answers: answers})
                        .then(function(response){
                            console.log('validateFormSS', response);
                            $scope.suggestions = response.data.suggestions;
                            $scope.merged_suggestions = $scope.suggestions['SS_F_Maintenir_'].concat($scope.suggestions['SS_F_Stop_'], $scope.suggestions['SS_F_Start_']);
                            console.log('merged_suggestions',($scope.merged_suggestions));
                            //update date
                            $scope.date_suggestions = $scope.formatDate(new Date(response.data.date_suggestions));

                        });
                    $rootScope.participantTracker.addPromise(promise);
                }
            };

            // set current question
            $scope.onFocus = function(e){
                console.log(e,'onFocus');
                $scope.currentSSQuestion = e.target;
            };

            // save answer of current question
            $scope.onBlur = function(){
                console.log('onBlur',$scope.currentSSQuestion.value, $scope.currentSSQuestion.name);
                let promise = $http.post('stopp-start/save-answer/' + $scope.participant.id, {key:$scope.currentSSQuestion.name, value: $scope.currentSSQuestion.value})
                    .then(function(response){
                        console.log('saved', response);

                    });
                $rootScope.participantTracker.addPromise(promise);
            };

            //this works only after validating the QRv
            $scope.$watch('participant.participantTraitementsByQuestionVisiteId', function() {
                // console.log($scope.participant.participantTraitementsByQuestionVisiteId, $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId], JSON.parse($scope.participant.participant_ss_etat.traitements_initiaux));
                if($scope.participant.participantTraitementsByQuestionVisiteId
                    && Object.keys($scope.participant.participantTraitementsByQuestionVisiteId).length
                    && $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]
                    && $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId].length
                ){
                    $scope.canFetchQuestions = true;
                    // flag if init atc list has changed since last STOPP/START launch
                    // console.log(JSON.stringify($scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]), $scope.participant.participant_ss_etat.traitements_initiaux);
                    if($scope.participant.participant_ss_etat && angular.toJson($scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]) != $scope.participant.participant_ss_etat.traitements_initiaux) {
                        $scope.initAtcListHasChanged = true;
                        console.log('initAtcListHasChanged');
                    }
                }else{
                    $scope.canFetchQuestions = false;
                }
            });

            $scope.addslashes = function(str){
                return str.replace(/'/g, "\\'");
            };

            $scope.formatDate= function(date) {
                return String(date.getDate()).padStart(2, '0') + "/" + String(date.getMonth()+1).padStart(2, '0') + "/" + date.getFullYear();
            }

            const objectsEqual = (o1, o2) =>
            Object.keys(o1).length === Object.keys(o2).length
            && Object.keys(o1).every(p => o1[p] === o2[p]);

            const arraysEqual = (a1, a2) =>
            a1.length === a2.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

            const init = function() {
                if($scope.participant.participantTraitementsByQuestionVisiteId
                    && Object.keys($scope.participant.participantTraitementsByQuestionVisiteId).length
                    && $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]
                    && $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId].length
                ){
                    $scope.canFetchQuestions = true;
                }else{
                    $scope.canFetchQuestions = false;
                }
                console.log($scope.initTreatmentsQvId, Object.keys($scope.participant.participantTraitementsByQuestionVisiteId), $scope.participant.participantTraitementsByQuestionVisiteId, $scope.participant.participantTraitementsByQuestionVisiteId[$scope.initTreatmentsQvId]);
                //load previous questions, if any
                if($scope.participant.participant_ss_etat ){
                    if($scope.participant.participant_ss_etat.questions){
                        $scope.questionsToAsk = $scope.participant.participant_ss_etat.questions;
                    $scope.date_questions = $scope.formatDate(new Date($scope.participant.participant_ss_etat.date_questions));
                    }
                    //load previous suggestions, if any
                    if($scope.participant.participant_ss_etat.suggestions){
                        $scope.merged_suggestions = $scope.participant.participant_ss_etat.suggestions;
                        $scope.initial_suggestions = angular.copy($scope.merged_suggestions);
                    // $scope.merged_suggestions = $scope.suggestions['SS_F_Maintenir_'].concat($scope.suggestions['SS_F_Stop_'], $scope.suggestions['SS_F_Start_']);
                    $scope.date_suggestions = $scope.formatDate(new Date($scope.participant.participant_ss_etat.date_suggestions));
                    }
                }
            };
            init();

            $scope.suggestions_are_dirty = function(){
                return !angular.equals($scope.merged_suggestions, $scope.initial_suggestions);
            };

            $scope.get_cc_colors = function(cc){
                return cc < 0 || cc === 0    ? "#8ae88a"
                               : cc === 1    ? "#c2d857"
                               : cc === 2    ? "#ffbc3b"
                               : cc === 3    ? "#ff6b3b"
                               : cc === null ? "#bfbfbf"
                               :               "#de1a1a";
            };

            $scope.get_current_traitement = function(suggestion) {
                let currentTraitement = [];

                if(suggestion['current_traitement']){
                    suggestion['current_traitement'].map(function(t){
                        currentTraitement.push(t['libelle_theriaque']);
                    });
                }

                return currentTraitement.length ? currentTraitement.join("<br/>") : suggestion['nomSpecialiteMedicale'];
            }

            $scope.validateSuggestion = function(suggestion, i){
                angular.element('#aSelected' + i).css('left', '66%');
                suggestion.isDeleted = false;
                suggestion.isValidated = true;
            };

            $scope.deleteSuggestion = function(suggestion, i){
                angular.element('#aSelected' + i).css('left', '0');
                suggestion.isDeleted = true;
                suggestion.isValidated = false;
            };
            $scope.validateAllSuggestion = function(){
                $scope.merged_suggestions.map(function(s, i){
                    $scope.validateSuggestion(s, i);
                });
            };
            $scope.deleteAllSuggestion = function(){
                $scope.merged_suggestions.map(function(s, i){
                    $scope.deleteSuggestion(s, i);
                });
            };

            $scope.checkIfAllChoicesAreMade = function(){
                // Check also if start treatment has been entered
                let response = true;
                $scope.merged_suggestions.map(function(s){
                    if(!s.isDeleted){
                        if(!s.isValidated || (s.action === 'start' && s.libelle_theriaque == null)){
                            response = false;
                        }
                    }
                });
                return response;
            };

            $scope.get_total_cc = function(){
                let total_cc = 0;
                $scope.merged_suggestions.map(function(s) {
                    if((s.action === 'stop' && s.isDeleted) ||
                       (s.action !== 'stop' && !s.isDeleted && s.isValidated)){
                        total_cc += s.cc;
                    }
                });
                return total_cc >= 0 ? total_cc : 0;
            };

            $scope.onTraitementStartSelected = function (selectedItem, s) {
                Object.keys(selectedItem).map(function(key) {
                    s[key] = selectedItem[key];
                });
                console.log("selectedItem", selectedItem)
            };
            $scope.traitement_conciliation_id = $scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__TRAITEMENT_CONCILIATION_MEDICAMENTEUSE').id;

            $scope.validateStopStart = function(){
                $scope.panier = $scope.merged_suggestions.map(function(s){
                   if(s.action === 'start'){
                       s.traitementsList = s.traitementsList.map(function(t){
                           if(t && t.ucd13){
                               return t.ucd13;
                           }
                       }).filter(function(f){return f != null;});
                   }
                    return s;
                });

                var firstVisiteKey = mbsEtiService.getCurrentEti().etudedefArray.visitesOrderedKeys[0];

                let promise = $http.post('stopp-start/save-panier/' + mbsEtiService.getCurrentEti().id + '/' + firstVisiteKey + '/' + $scope.participant.id, {panier: $scope.panier}).then(function(r){
                    $scope.traitement_conciliation_id = $scope.visite.getQuestionVisiteForQuestionMereKeyShort('QM__TRAITEMENT_CONCILIATION_MEDICAMENTEUSE').id;
                    $scope.participant.participantTraitementsByQuestionVisiteId[$scope.traitement_conciliation_id] =
                        r.data.participant_traitements.filter(function(t){
                            return t.question_visite_def_id === $scope.traitement_conciliation_id;
                        });
                    $scope.participant.participant_ss_etat = r.data.participant_ss_etat;
                    $scope.questionsToAsk = r.data.participant_ss_etat.questions;
                    $scope.merged_suggestions = r.data.participant_ss_etat.suggestions;
                    $scope.initial_suggestions = angular.copy($scope.merged_suggestions);
                });
                $rootScope.participantTracker.addPromise(promise);
            };
    }]
);



// WEBPACK FOOTER //
// ./resources/assets/js/controllers/etude/participantSS.js